import { useState } from "react";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { AGENT_SETTINGS } from "@/constants/testIds";
import { formatPrice } from "@/lib/pricingUtils";
import KnowledgeModal, { KNOWLEDGE_FIELDS } from "@/components/agent/KnowledgeModal";

/** Tabla de servicios con su informacion cualitativa para la knowledge
 * base del agente (precio/duracion vienen del catalogo de Servicios). */
export default function KnowledgeTab({ knowledge, loading, onUpdate }) {
  const [editing, setEditing] = useState(null);

  if (loading) return <p className="text-sm text-muted-foreground">Cargando...</p>;

  return (
    <>
      <div className="bg-white border border-border rounded-xl overflow-hidden" data-testid={AGENT_SETTINGS.knowledgeTable}>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tratamiento</TableHead>
              <TableHead>Precio</TableHead>
              <TableHead>Completitud de la info</TableHead>
              <TableHead className="text-right">Acciones</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {knowledge.map((k) => {
              const filled = KNOWLEDGE_FIELDS.filter((f) => k[f.key]).length;
              return (
                <TableRow key={k.service_id} data-testid={`${AGENT_SETTINGS.knowledgeRowPrefix}${k.service_id}`}>
                  <TableCell className="font-medium">{k.service_name}</TableCell>
                  <TableCell>{formatPrice(k.price, k.price_type, k.price_note)}</TableCell>
                  <TableCell className="text-muted-foreground text-sm">{filled}/{KNOWLEDGE_FIELDS.length} campos completos</TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="icon" onClick={() => setEditing(k)} data-testid={`${AGENT_SETTINGS.knowledgeEditButtonPrefix}${k.service_id}`}>
                      <Pencil className="w-4 h-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <KnowledgeModal open={Boolean(editing)} onOpenChange={(v) => !v && setEditing(null)} item={editing} onSubmit={onUpdate} />
    </>
  );
}
